<template>
    <sidebar :data="data"
             :logo-url="urlGenerator('/')"
             :logo-src="urlGenerator(logo)"
             :logo-icon-src="urlGenerator(logo)"
             :company-name="configData.company_name"
    />

</template>

<script>
import {urlGenerator} from "../../../Helpers/AxiosHelper";
import { AuthMixin } from "../Auth/Mixins/AuthMixin";

export default {
    name: 'DashboardSidebar',
    mixins: [AuthMixin],
    props: {
        data: {
            required: true
        },
        logo: {
            type: String,
        },
        logoIcon: {
            type: String,
        }
    },
    data() {
        return {
            urlGenerator
        }
    }
}
</script>
